import React from 'react'
import {Row, Col} from 'reactstrap'
import Page from 'ui/page'
import aboutUs from 'goforajourney/img/about-us'

const AboutUs = (props) => {
  return (
    <Page {...props}>
      <div className="mb-5">
        <section>
          <h1 className="mb-3">About GoforaJourney</h1>
          <p><span className="text-primary font-weight-bold">GoforaJourney</span> was born from a shared passion: the joy of dedicating time to what truly moves us. We're a team of experts and enthusiasts who believe that hobbies and free-time passions deserve more space—and more magic.</p>
        </section>

        <section>
          <p>We design and curate experiences, retreats, trips, and activities, all structured around specific interests or “verticals.” From gastronomy to painting, culture to flamenco, GoforaJourney organizes ongoing activities across the globe—each tailored for people who want to explore or deepen a particular passion.</p>
        </section>

        <Row>
          <Col xs="12" md="7">
            <section>
              <p>Over the years, many of us behind this project have worked in industries driven by profit margins or dictated by brands and trends. GoforaJourney is our chance to do things differently. To do what we love, the way we love it—guided by true specialists. That’s why a culinary experience with us isn’t just about what Nacho or Edgar like to eat—it’s designed and curated by local culinary experts: chefs, critics, scholars, and more.</p>
            </section>

            <section>
              <p>Similarly, our week-long painting retreats are led by seasoned art instructors. Our cultural journeys are guided by geologists and historians. And our themed getaways are designed so you can fully immerse yourself in whatever brings you joy, whether alone or with your family.</p>
            </section>

            <section>
              <h2 className="h3">What makes GoforaJourney special?</h2>
              <p>It’s not just the experiences—it’s the people. We’ve found our community in those who see these journeys as a way to step out of the everyday and dive into what they’re passionate about.</p>
            </section>

            <section>
              <p>But we’re not stopping there.</p>
              <p>GoforaJourney aims to build more than just moments—we’re building a community. Over the coming years, we’ll offer services for both hobbyists and the professionals who inspire them. Whether you’re looking to enjoy a retreat, host a workshop, collaborate on a project, or connect with fellow creatives, we want to be your platform.</p>
            </section>

            <section>
              <p>We envision a dynamic hub—a "Dome"—where amateurs and professionals meet. A space for seminars, project showcases, equipment and tool marketplaces (for cooking, painting, dancing, and more), and of course, unforgettable experiences.</p>
            </section>

            <section>
              <p>To support this vision, we’re partnering with a tech team to build out our own platform. Step by step, we’re introducing custom-built tools to manage our community and grow alongside it. We will keep you posted!</p>
            </section>

            <section>
              <p><strong className="h4 font-italic"><span className="text-primary">GoforaJourney</span> is where passion meets purpose.</strong><br/>
              Welcome to your next adventure.</p>
            </section>
          </Col>
          <Col xs="12" md="5">
            <img className="rounded-lg" alt="Goforajourney About Us" src={aboutUs} width="100%" height="100%"/>
          </Col>
        </Row>
      </div>
    </Page>
  )
}

export default AboutUs
